import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import ErrorLayout from './ErrorLayout';
import HelpfulLinks from './HelpfulLinks';
import { useFallbackLayout } from '@fhnw/hooks/useFallbackLayout';
import ParentLink from './ParentLink';

const Unauthorized: React.FC = () => {
  useFallbackLayout();
  return (
    <ErrorLayout
      title={
        <FormattedMessage id="error.401.title" defaultMessage="Unauthorized" />
      }
    >
      <div className="blocks-group-wrapper transparent">
        <p className="documentDescription">
          <FormattedMessage
            id="error.404.lead"
            defaultMessage="We apologize for the inconvenience, but the page you were trying to access is not at this address. You can use the links below to help you find what you are looking for."
          />
        </p>
        <ParentLink />
        <HelpfulLinks />
      </div>
    </ErrorLayout>
  );
};

// Respond with 404 for SEO purposes
export default withServerErrorCode(404)(Unauthorized);
